function isStringNumeric(str: string | undefined): boolean {
  if (str) {
    return /^[0-9]+$/.test(str);
  } else {
    return false;
  }
}

export { isStringNumeric };
